import type { EchoMissionDetail } from '@vtak/shared';
import { BrainCircuit } from 'lucide-react';

/** Mission analysis section showing AI-generated outputs */
export function EchoAnalysis({ detail }: { detail: EchoMissionDetail }): React.JSX.Element {
  return (
    <section>
      <h3 className="mb-2 flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
        <BrainCircuit className="h-3.5 w-3.5" />
        Mission Analysis
      </h3>
      {detail.analysisOutputs.length === 0 ? (
        <p className="text-sm text-muted-foreground">No analysis available</p>
      ) : (
        <ul className="flex flex-col gap-2">
          {detail.analysisOutputs.map((output, i) => (
            <li key={i} className="rounded-md bg-white/[0.04] px-3 py-2 text-sm">
              <p className="whitespace-pre-wrap text-[13px] leading-relaxed">{output.content}</p>
              {output.createdAt && (
                <span className="mt-1 block text-[10px] text-muted-foreground">
                  {formatTimestamp(output.createdAt)}
                </span>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

/** Format a timestamp string for display */
function formatTimestamp(ts: string): string {
  try {
    return new Date(ts).toLocaleString();
  } catch {
    return ts;
  }
}
